<template>
    <div class="button" @click="handleLivePrize()">
        {{ text }}
    </div>
</template>
<script>
import TaskModel from './../../../../../models/task'
const taskModel = new TaskModel()
export default {
    props: {
        taskId: {
            default: null
        },
        userType: {
            default: null
        }
    },
    // watch: {
    //     userType(val) {
    //         if (val === 1) {
    //             this.text = "领取奖励"
    //         } else {
    //             this.text = "好的"
    //         }

    //     }
    // },
    data() {
        return {
            text: ''
        }
    },
    mounted() {
        if (this.userType === 1) {
            this.text = "领取奖励"
        } else {
            this.text = "好的"
        }
    },
    methods: {
        handleLivePrize() {
            if (this.text === "领取奖励") {
                taskModel.postLivePrize({ taskId: this.taskId }).finally(() => {
                    this.$emit('closeRule')
                })
            } else {
                this.$emit('closeRule')
            }

        }
    }
}
</script>
<style scoped lang="stylus">
@import "./index.styl"
</style>